exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".go-back[data-v-4e3e1817]{display:-webkit-box;display:-ms-flexbox;display:flex;cursor:pointer;position:absolute;left:170px;height:40px;border:1px solid;width:100px}button[data-v-4e3e1817]{border:0;background-color:#fff}a[data-v-4e3e1817]:active,a[data-v-4e3e1817]:hover,a[data-v-4e3e1817]:link,a[data-v-4e3e1817]:visited{text-decoration:none}a[data-v-4e3e1817]{color:var(--q-color-primary)!important;-webkit-transform:translate(45%,20%);transform:translate(45%,20%)}.go-back[data-v-4e3e1817]:hover{height:40px;background-color:var(--q-color-secondary)!important;border-radius:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e3e1817","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/GoBack.vue
// module id = +xeo
// module chunks = 83